export const trunk = {
  field: {
    my_ip: 'IP Address Saya',
    zorra_ip: 'IP Address Zorra ',
    type: 'Arah',
    prefix: 'Prefix',
    state: 'Status',
    trunk_type: 'Layanan'
  },

  trunk_type: {
    inc_voice: 'Panggilan masuk',
    out_voice: 'Panggilan keluar',
    pbx_inc_voice: 'Panggilan masuk PBX',
    pbx_out_voice: 'Panggilan keluar PBX',
    autocaller_inc_voice: 'Pemanggil Prediktif otomatis masuk',
    autocaller_out_voice: 'Pemanggil Prediktif otomatis kelua',
    call_number_verification: 'Verifikasi nomor'
  },

  type: {
    outgoing: 'Outgoing',
    caller: 'Pemanggil',
    incoming: 'Incoming',
    inc_voice: 'Panggilan masuk',
    out_voice: 'Panggilan keluar',
    pbx_inc_voice: 'Panggilan masuk PBX',
    pbx_out_voice: 'Panggilan keluar PBX',
    autocaller_inc_voice: 'Panggilan masuk Autoinformer',
    autocaller_out_voice: 'Panggilan keluar Autoinformer',
    amo_inc_voice: 'Widget suara masuk amoCRM',
    amo_out_voice: 'Widget suara keluar amoCRM',
    kommo_inc_voice: 'Widget suara masuk Kommo CRM',
    kommo_out_voice: 'Widget suara keluar Kommo CRM',
    call_number_verification: 'Verifikasi nomor',
    predictive_inc_voice: 'Panggilan masuk prediktif',
    predictive_out_voice: 'Panggilan keluar prediktif',
    voice_number_verification: 'Verifikasi dengan kode audio',
    phone_number_verification: 'Verifikasi panggilan masuk',
    all: 'Semua'
  },

  modal: {
    edit: 'Sunting SIP trunks',
    remove: {
      content: 'Anda yakin ingin menghapus nama trunk {name}?'
    },
    myip_tooltip: 'Alamat IP utama tidak dapat diedit.',
    ip_exist: 'Alamat IP sudah diambil'
  },

  button: {
    create: 'Buat trunk',
    tooltip: 'Isi saldo Anda untuk membuat bagasi',
    show_default_trunks: 'Tampilkan batang default'
  },

  errors: {
    trunk_limit: 'Batas batang terlampaui',
    ip_exist: 'Alamat IP sudah dipakai orang lain'
  },

  show_all: 'Show all'
};
